import { Component } from 'react';
import ActivateDomain from '../../ActivateDomain/Domain';
import { withTranslation } from 'react-i18next';

class ActivateDomains extends Component {
    constructor() {
        super();

        this.changeDisableAll = this.changeDisableAll.bind(this);

        this.state = {
            disableAll: false,
        };
    }

    changeDisableAll(boolean) {
        this.setState({
            disableAll: boolean,
        });
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="padding-x-20">
                    <div id="onboarding-general-settings">
                        <div className="onboarding-step-3">
                            {this.props.domains?.length === 0 && 'Please add domains in Step 2.'}
                            {this.props.domains?.map((item) => (
                                <div
                                    key={item.url}
                                    className="onboarding-step-3-switch-button d-flex mb-10"
                                >
                                    <div className="mr-10 d-flex align-items-center">
                                        <ActivateDomain
                                            domain_pk={item.pk}
                                            active_domain={item.status}
                                            domain_url={item.url}
                                            csrf_token={this.props.csrf_token}
                                            disableAll={this.state.disableAll}
                                            changeDisableAll={this.changeDisableAll}
                                            from_onboarding
                                        />
                                    </div>
                                    <div className="item-url">{item?.url}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="onboarding-container-item-body-footer">
                    <button
                        className="onboarding-skip-btn"
                        style={{ lineHeight: 'unset' }}
                        onClick={() => this.props.handleBack()}
                    >
                        {t('onboarding.back')}
                    </button>
                    <button
                        className="onboarding-btn-next"
                        onClick={() => this.props.handleNext()}
                        disabled={this.props.isDisabledNext}
                    >
                        {t('onboarding.next')}
                    </button>
                </div>
            </>
        );
    }
}

export default withTranslation()(ActivateDomains);
